import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { HomePage } from './pages/HomePage'
import { ClassesPage } from './pages/ClassesPage'
import { StudentsPage } from './pages/StudentsPage'
import { StudentProfilePage } from './pages/StudentProfilePage'

// Module Évaluation Comportementale
import { EvaluationModulePage } from './pages/modules/evaluation/EvaluationModulePage'
import { EvaluationGridsListPage } from './pages/modules/evaluation/EvaluationGridsListPage'
import { CreateEvaluationGridPage } from './pages/modules/evaluation/CreateEvaluationGridPage'
import { EditEvaluationGridPage } from './pages/modules/evaluation/EditEvaluationGridPage'
import { EvaluationSessionSetupPage } from './pages/modules/evaluation/EvaluationSessionSetupPage'
import { EvaluationSessionPage } from './pages/modules/evaluation/EvaluationSessionPage'
import { EvaluationResultsPage } from './pages/modules/evaluation/EvaluationResultsPage'

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: 1
    }
  }
})

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <BrowserRouter basename="/">
        <Routes>
          {/* Accueil */}
          <Route path="/" element={<HomePage />} />

          {/* Gestion Classes */}
          <Route path="/classes" element={<ClassesPage />} />

          {/* Gestion Élèves */}
          <Route path="/students" element={<StudentsPage />} />

          {/* Profil Élève */}
          <Route path="/students/:id" element={<StudentProfilePage />} />

          {/* Module Évaluation Comportementale - Landing */}
          <Route path="/modules/evaluation" element={<EvaluationModulePage />} />

          {/* Module Évaluation - Grilles */}
          <Route path="/modules/evaluation/grids" element={<EvaluationGridsListPage />} />
          <Route path="/modules/evaluation/grids/new" element={<CreateEvaluationGridPage />} />
          <Route path="/modules/evaluation/grids/:id/edit" element={<EditEvaluationGridPage />} />

          {/* Module Évaluation - Sessions */}
          <Route path="/modules/evaluation/evaluate" element={<EvaluationSessionSetupPage />} />
          <Route path="/modules/evaluation/evaluate/:gridId/:classId" element={<EvaluationSessionPage />} />

          {/* Module Évaluation - Résultats */}
          <Route path="/modules/evaluation/results" element={<EvaluationResultsPage />} />

          {/* Redirect old routes vers landing */}
          <Route path="/dashboard" element={<Navigate to="/" replace />} />
          <Route path="/sign-in" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </QueryClientProvider>
  )
}

export default App
